import React from 'react'
import {
  stepAgentConfig,
  stepAgentConfigPipeline,
  stepInteractContrastUI,
  stepSelectContainerMethod,
  stepSelectLinuxMacOSNormalize
} from './common'
import { formatStyles } from '../../../../react-intl-helpers'
import { ImageIcon } from '../common/image-icon'
import { logo_docker, logo_manual, logo_pipeline } from '../images'
import {
  stepSelectKubernetesOperator,
  stepKubernetesLabelDeployments as stepKubernetesLabelDeploymentsPython,
  stepKubernetesDownloadSetup,
  stepKubernetesInstallDeployHelm
} from './common-kubernetes'
import {
  stepContainerInstallOperator,
  stepContainerConfigureOperator,
  stepContainerInjectWorkloads as stepContainerInjectWorkloadsPython,
  stepContainerClusterAgentAndAgent
} from './common-container'
import {
  IconBitbucket,
  IconGithub
} from '@contrast-security-inc/design-system-foundations'
import { OPERATING_SYSTEM } from '../common/constants'

const stepKubernetesLabelDeployments =
  stepKubernetesLabelDeploymentsPython('PYTHON')

const stepContainerInjectWorkloads =
  stepContainerInjectWorkloadsPython('PYTHON')

const commonFinalSteps = [stepInteractContrastUI]

const installMethods = {
  titleMsg: 'title_applicationDeploymentMethod',
  defaultIsOpen: true,
  Content: {
    options: [
      {
        value: 'manually',
        Content: 'Install manually',
        icon: <ImageIcon src={logo_manual} alt="manually" />
      },
      {
        value: 'container',
        Content: 'Install with a container',
        icon: <ImageIcon src={logo_docker} alt="container" />
      },
      {
        value: 'pipeline',
        Content: {
          message: 'title_installPipeline'
        },
        icon: <ImageIcon src={logo_pipeline} alt="container" />
      }
    ]
  }
}

const dockerSteps = [
  {
    titleMsg: 'title_buildImageWithAgent',
    defaultIsOpen: true,
    Content: {
      message: 'detail_installImageWithAgentPython',
      values: {
        ...formatStyles.doclink({ path: 'python-middleware.html' })
      }
    }
  },
  stepAgentConfig,
  ...commonFinalSteps
]

const stepsLinuxContainer = [
  {
    ...stepSelectContainerMethod,
    branchKey: 'python-container-method',
    branches: {
      docker: dockerSteps,
      kubernetes: [
        {
          ...stepSelectKubernetesOperator,
          branchKey: 'node-kubernetes-op',
          branches: {
            helm: [
              stepKubernetesDownloadSetup,
              stepKubernetesLabelDeployments,
              stepKubernetesInstallDeployHelm,
              ...commonFinalSteps
            ],
            manifest: [
              stepContainerInstallOperator,
              stepContainerConfigureOperator,
              stepContainerInjectWorkloads,
              stepContainerClusterAgentAndAgent,
              ...commonFinalSteps
            ]
          }
        }
      ]
    }
  }
]

const stepSelectPipelineMethod = {
  defaultIsOpen: true,
  titleMsg: 'title_selectDeployMethodPipeline',
  Content: {
    options: [
      {
        value: 'github',
        Content: 'Github',
        icon: <IconGithub color="black" />
      },
      {
        value: 'bitbucket',
        Content: 'Bitbucket',
        icon: <IconBitbucket color="blue50" />
      }
    ]
  }
}

const githubInstallAgent = {
  defaultIsOpen: true,
  titleMsg: 'title_installAgent',
  Content: {
    message: 'detail_installGithubPython',
    values: {
      code1: `- name: Install Agent
  shell: bash
  run: pip install contrast-agent
`,
      code2: `env:
   CONTRAST__API__TOKEN: \${{ secrets.ContrastAPIToken }}
   CONTRAST__APPLICATION__NAME: \${{ secrets.ContrastApplicationName }}
   CONTRAST__APPLICATION__METADATA: \${{ secrets.ContrastApplicationMetadata }}
   ...
   steps:
     - name: Run with Contrast
       shell: bash
       run: contrast-python-run -- [original application startup command]
`,
      token: '{{ secrets.ContrastAPIToken }}',
      name: '{{ secrets.ContrastApplicationName }}',
      metadata: '{{ secrets.ContrastApplicationMetadata }}',
      options: '"-javaagent:/contrast.jar"'
    }
  }
}

const bitbucketInstallAgent = {
  defaultIsOpen: true,
  titleMsg: 'title_installAgent',
  Content: {
    message: 'detail_installBitbucketPython',
    values: {
      code: `- step:
  script:
    - pip install contrast-agent
`
    }
  }
}

const pipelineSteps = [
  {
    ...stepSelectPipelineMethod,
    branchKey: 'pipeline-method',
    branches: {
      github: [
        githubInstallAgent,
        stepAgentConfigPipeline,
        ...commonFinalSteps
      ],
      bitbucket: [
        bitbucketInstallAgent,
        stepAgentConfigPipeline,
        ...commonFinalSteps
      ]
    }
  }
]

const branches = {
  manually: [
    {
      titleMsg: 'title_installAgent',
      defaultIsOpen: true,
      Content: { message: 'detail_installAgentPython' }
    },
    stepAgentConfig,
    {
      titleMsg: 'title_installRunner',
      Content: {
        message: 'detail_installRunnerNormalize',
        values: {
          ...formatStyles.doclink({ path: 'contrast-runner.html' })
        }
      }
    },
    ...commonFinalSteps
  ],
  container: stepsLinuxContainer,
  pipeline: pipelineSteps
}

export const pythonWizardStepsNormalizeAgentDownload = [
  { ...stepSelectLinuxMacOSNormalize, branchKey: OPERATING_SYSTEM.KEY },
  { ...installMethods, branchKey: 'node-install', branches }
]
